document.addEventListener('DOMContentLoaded', () => {
  const checkoutBtn = document.querySelector('#checkout');
  const warning = document.querySelector('#cart-min-warning');
  const minAmount = 50 * 100; // £50 in pence

  if (!checkoutBtn) return;

  async function checkMinimum() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      if (cart.total_price < minAmount) {
        checkoutBtn.disabled = true;
        if (warning) {
          warning.textContent = `Minimum order amount is £${minAmount / 100}. Please add more items.`;
        }
      } else {
        checkoutBtn.disabled = false;
        if (warning) warning.textContent = '';
      }
    } catch (err) {
      console.error('Cart check failed:', err);
    }
  }

  // Initial check
  checkMinimum();

  // Poll periodically for AJAX updates
  setInterval(checkMinimum, 500);

  // Extra protection: prevent click if below minimum
  checkoutBtn.addEventListener('click', async (e) => {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    if (cart.total_price < minAmount) {
      e.preventDefault();
      alert(`Minimum order amount is £${minAmount / 100}. Please add more items.`);
    }
  });

  // Listen to quantity changes
  document.querySelectorAll('.quantity__input').forEach(input => {
    input.addEventListener('change', () => setTimeout(checkMinimum, 400));
  });
});
